import styled from '@emotion/styled';
import React from 'react';
import { mqMin } from 'utils/responsive';

const DescriptionText = styled.p`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 0.96rem;
    line-height: 160%;
    letter-spacing: 0.8px;
    color: #1e4e66;
    margin: 0;
`;

const HighlightText = styled.span`
    font-weight: 700;
    color: #ee793f;
    background-color: #fffbc9;
`;

const SuccessionTypesContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    margin: 40px auto 0 auto;
    flex-direction: column;

    ${mqMin('SP')} {
        gap: 44px;
        flex-direction: row;
        align-items: flex-start;
    }
`;

const SuccessionTypeItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`;

const CircleWrapper = styled.div`
    position: relative;
    width: 118px;
    height: 119px;
    flex-shrink: 0;
`;

const CircleOutlined = styled.div`
    width: 118px;
    height: 119px;
    border-radius: 50%;
    border: 3px solid #1695d4;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const CircleFilled = styled.div`
    width: 118px;
    height: 119px;
    border-radius: 50%;
    background: #1695d4;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const CircleLabel = styled.div`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 160%;
    letter-spacing: 0.8px;
    color: #1695d4;
    text-align: center;
`;

const CircleLabelWhite = styled(CircleLabel)`
    color: #fff;
`;

const DescriptionLabel = styled.div`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 160%;
    letter-spacing: 0.7px;
    color: #1e4e66;
    text-align: center;
    white-space: pre-line;
`;

const DescriptionLabelBold = styled(DescriptionLabel)`
    font-weight: 700;
`;

export const MaForBeginnerDerail_1_1: React.FC = () => {
    return (
        <>
            <DescriptionText>
                事業承継には、大きく分けて「親族承継」「社内承継」「第三者承継（M&A）」の3つがあります。親族承継は、子どもや親族に事業を引き継ぐ伝統的な形ですが、少子化や後継者不足により難しくなっています。社内承継は、役員や社員に引き継ぐ方法で、事業の理解度は高いものの資金調達の課題が残ります。これに対し、第三者承継であるM&Aは、外部の企業や個人に会社を譲渡する形です。後継者問題を根本的に解決できる点が魅力であり、
                <HighlightText>
                    従業員の雇用維持や取引先の信頼を守りながら、オーナー自身のリタイアや新たな挑戦の資金確保にもつながります。
                </HighlightText>
            </DescriptionText>
            <SuccessionTypesContainer>
                <SuccessionTypeItem>
                    <CircleWrapper>
                        <CircleOutlined>
                            <CircleLabel>親族承継</CircleLabel>
                        </CircleOutlined>
                    </CircleWrapper>
                    <DescriptionLabel>{'子どもや親族に\n引き継ぐ'}</DescriptionLabel>
                </SuccessionTypeItem>
                <SuccessionTypeItem>
                    <CircleWrapper>
                        <CircleOutlined>
                            <CircleLabel>社内承継</CircleLabel>
                        </CircleOutlined>
                    </CircleWrapper>
                    <DescriptionLabel>{'社員や社員に\n引き継ぐ'}</DescriptionLabel>
                </SuccessionTypeItem>
                <SuccessionTypeItem>
                    <CircleWrapper>
                        <CircleFilled>
                            <CircleLabelWhite>{'第三者承継\n（M&A）'}</CircleLabelWhite>
                        </CircleFilled>
                    </CircleWrapper>
                    <DescriptionLabelBold>{'外部の企業や\n個人に会社を譲渡'}</DescriptionLabelBold>
                </SuccessionTypeItem>
            </SuccessionTypesContainer>
        </>
    );
};
